const name = 'NoTransition';
const properties = {
    defaultDuration: 0,
    schema: {
        duration: {
            type: 'number',
            min: 0,
            default: 0,
        },
        delay: {
            type: 'number',
            min: 0,
            default: 0,
        },
    },
};
/**
 * Empty transition.
 */
function transition(kit, sourceElements, destElements, duration, delay, params) {
    const sequence = kit.sequence(params);
    sequence.add([
        kit.animate('BaseNone', sourceElements, duration, delay),
        kit.animate('BaseNone', destElements, duration, delay),
    ]);
    return sequence.get();
}
export { name, properties, transition };
//# sourceMappingURL=noTransition.js.map